<template>
  <v-dialog
      persistent
      max-width="980px"
      v-model="showDlg"
  >
    <v-card>
      <v-card-title>
        <span class="toptitle">{{ title }}</span>
        <v-spacer></v-spacer>
        <span>[{{selectedCountries.length}} / {{ allCountries.length }}]</span>
      </v-card-title>

      <v-card-text>
        <v-container>

          <v-card class="scroll justify-start" height="200px" outlined tile>
            <v-chip class="cat-chip"
                v-for="(country) in selectedCountries"
                :key="country.id"
                :active="country.selected"
                close
                @click:close="onCloseSelected(country)"
            >{{ country.name }}</v-chip>
          </v-card>

          <v-card class="d-flex justify-start" height="50px">
            <v-text-field
                v-model="countryFilter"
            ></v-text-field>
            <v-spacer></v-spacer>
          </v-card>

          <v-card class="scroll" height="300px">
            <div
              v-for="(country, idx) in filteredCountries"
              tabindex="-1"
              :key="country.id"
              :data-index="idx"
              label
              :class="country.selected ? 'cat-item cat-item-active tooltip' : 'cat-item tooltip'"
              @click="onCheckCountry(country, $event)"
              @keyup.up="onActive(idx-1)"
              @keyup.down="onActive(idx+1)"
              @keypress.space.prevent="onCheckCountry(country, $event)"
            >
              {{country.name}}
            </div>
          </v-card>

        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click="onCheckAll">{{$t('EASYSELECT_SELECT_ALL')}}</v-btn>
        <v-btn color="blue darken-1" text @click="onUncheckAll">{{$t('EASYSELECT_SELECT_NONE')}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="onClose">{{$t('GENERIC_CANCEL')}}</v-btn>
        <v-btn class="btnapply" text @click="onApply">{{$t('GENERIC_APPLY')}}</v-btn>
      </v-card-actions>
    </v-card>

    <Dialog ref="dialog" />
  </v-dialog>
</template>



<script>
  import {mapGetters} from "vuex";
  import Dialog from './common/Dialog'

  export default {
    name: "CountrySelField",
    components: {
      Dialog
    },
    data: () => ({
      countryId: 0,
      countryFilter: '',
      title: '',
      notifications: false,
      sound: false,
      video: false,
      invites: false,
      showDlg: false,
      prevSelCountry: null,
      allCountries: [],
      multiple: false,
      activeIndex: 0,
      date: null,
      newCat: {
        name: '',
        desc: '',
        directly: false,
      },
      foundCountry: {},
    }),

    computed: {
      ...mapGetters(['countries']),
      selectedCountries() {
        return this.allCountries.filter(c => c.selected)
      },
      filteredCountries() {
        const lcountryFilter = this.countryFilter.toLowerCase()
        const countryArray = this.allCountries.filter( c => {
          const lName = c.name.toLowerCase()
          return (
          (!lcountryFilter || lName.indexOf(lcountryFilter) >= 0) // if filter is empty OR cat.name contains the filter
        )})
        return countryArray
      }
    },

    watch: {
      activeIndex(index) {
        this.focusTR(index)
      },
    },

    methods: {
      onCloseSelected(cat) {
        cat.selected = false
      },
      onOpen(countryIds) {
        this.allCountries = [];
        this.countries.forEach(country => {
          this.allCountries.push({
            id: country.id,
            name: country.name,
            selected: countryIds.includes(country.id),
          })
        });
        this.showDlg = true
      },
      onApply() {
        this.$emit('select', {
          countryIds: this.selectedCountries.map(c => c.id)
        })
        this.showDlg = false
      },
      onClose() {
        this.showDlg = false
      },
      onCheckAll() {
        this.filteredCountries.forEach(c => c.selected = true)
      },
      onUncheckAll() {
        this.filteredCountries.forEach(c => c.selected = false)
      },
      onActive(index) {
        if (index !== null && index >= 0 && index <= this.filteredCountries.length - 1) {
          this.activeIndex = index
        }
      },
      focusTR(index){
        let selected = document.querySelector('[data-index="'+index+'"]')
        if (selected) {
          selected.focus()
        }
      },
      onCheckCountry(country) {
        this.$set(country, 'selected', !country.selected);
      }
    }
  }
</script>

<style scoped>
.scroll {
  overflow-y: auto;
}

.cat-chip {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 2px;
  margin-right: 2px;
}

.cat-item {
  padding: 5px;
  margin-top: 1px;
  border: 1px solid darkgray;
  border-radius: 5px;
}

.cat-item-active {
  background: rgba(51,153,0,.25);
}

.btnapply {
  color:  rgb(49, 103, 128);;
  background-color: rgba(148, 224, 117, 0.623);
}

</style>